import { Contact } from '../contact';
export class Branch {
    constructor(
        public id?: number,
        public name?: string,
        public description?: string,
        public branchNumber?: number,
        public city?: string,
        public branchMaster?: Contact,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/branch/branch.model.ts